import React, { useState } from 'react';
import './Modal.css';

const formatAddress = (addressData) => {
    if (!addressData) return '';

    const parts = [
        addressData.address,
        addressData.address_2,
        addressData.city,
        addressData.state,
        addressData.zip,
        addressData.country,
    ].filter(Boolean);

    return parts.join(', ');
};

const ShippingAddressModal = ({
    show,
    savedAddresses,
    onClose,
    onSelectAddress,
    onDeleteAddress,
    onEditAddress,
}) => {
    const [confirmDeleteAddress, setConfirmDeleteAddress] = useState(null);
    const [searchTerm, setSearchTerm] = useState('');

    if (!show) return null;

    const handleConfirmDelete = () => {
        if (confirmDeleteAddress) {
            onDeleteAddress(confirmDeleteAddress.id || confirmDeleteAddress.address_id);
            setConfirmDeleteAddress(null);
        }
    };

    const filteredAddresses = (savedAddresses || []).filter((addr) => {
        if (!searchTerm.trim()) return true;
        const term = searchTerm.toLowerCase();
        const nickname = (addr.nick_name || '').toLowerCase();
        const fullAddr = formatAddress(addr).toLowerCase();
        return nickname.includes(term) || fullAddr.includes(term);
    });

    return (
        <>
            <div className="motor-modal-overlay" onClick={onClose}>
                <div
                    className="motor-modal-content purchase-order-address-modal"
                    style={{ maxWidth: '600px', width: '90%', padding: 0 }}
                    onClick={(e) => e.stopPropagation()}
                >
                    {/* Modal Header */}
                    <div className="modal-header-dark">
                        <h4 className="m-0">
                            Saved Addresses
                        </h4>
                        <button
                            type="button"
                            className="btn-close btn-close-white"
                            onClick={onClose}
                            aria-label="Close"
                        ></button>
                    </div>

                    {/* Modal Body */}
                    <div className="modal-body-content" style={{ padding: '20px', minHeight: '150px' }}>
                        {/* Subtitle */}
                        <div className="mb-3">
                            <span className="fw-semibold text-secondary">Select a saved shipping address</span>
                        </div>

                        {savedAddresses && savedAddresses.length > 10 && (
                            <div className="mb-3">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Search saved addresses by nickname or address..."
                                    value={searchTerm}
                                    onChange={(e) => setSearchTerm(e.target.value)}
                                />
                            </div>
                        )}

                        {filteredAddresses.length > 0 ? (
                            <div className="list-group">
                                {filteredAddresses.map((address) => (
                                    <div key={address.id || address.address_id} className="list-group-item d-flex justify-content-between align-items-center gap-3">
                                        <button
                                            type="button"
                                            className="btn btn-link text-start text-dark p-0 flex-grow-1 text-decoration-none"
                                            onClick={() => onSelectAddress(address)}
                                        >
                                            <div className="fw-semibold" style={{ color: '#313131' }}>
                                                {address.nick_name || 'Shipping Address'}
                                            </div>
                                            <div className="small text-muted">{formatAddress(address)}</div>
                                        </button>
                                        <div className="d-flex gap-2 align-items-center">
                                            {onEditAddress && (
                                                <button
                                                    type="button"
                                                    className="btn submit-button btn-sm"
                                                    onClick={() => onEditAddress(address)}
                                                >
                                                    Edit
                                                </button>
                                            )}
                                            <button
                                                type="button"
                                                className="btn btn-outline-danger btn-sm"
                                                onClick={() => setConfirmDeleteAddress(address)}
                                            >
                                                Delete
                                            </button>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        ) : (
                            <div className="text-muted border rounded p-3 bg-light text-center">
                                No saved addresses yet.
                            </div>
                        )}
                    </div>

                    {/* Modal Footer */}
                    <div className="modal-footer-dark">
                        <button type="button" className="btn btn-secondary px-4" onClick={onClose}>
                            Close
                        </button>
                    </div>
                </div>
            </div>

            {/* Confirmation Modal before deletion */}
            {confirmDeleteAddress && (
                <div className="motor-modal-overlay" style={{ zIndex: 1100 }} onClick={() => setConfirmDeleteAddress(null)}>
                    <div
                        className="motor-modal-content purchase-order-address-modal"
                        style={{ maxWidth: '420px', width: '90%', padding: 0 }}
                        onClick={(e) => e.stopPropagation()}
                    >
                        <div className="modal-header-dark">
                            <h4 className="m-0">
                                Confirm Delete
                            </h4>
                            <button
                                type="button"
                                className="btn-close btn-close-white"
                                onClick={() => setConfirmDeleteAddress(null)}
                                aria-label="Close"
                            ></button>
                        </div>
                        <div className="modal-body-content" style={{ padding: '20px' }}>
                            <p className="mb-0 text-secondary">
                                Are you sure you want to delete the address <strong>"{confirmDeleteAddress.nick_name || formatAddress(confirmDeleteAddress)}"</strong>?
                            </p>
                        </div>
                        <div className="modal-footer-dark">
                            <button
                                type="button"
                                className="btn btn-danger px-4"
                                onClick={handleConfirmDelete}
                            >
                                Delete
                            </button>
                            <button
                                type="button"
                                className="btn btn-secondary px-4"
                                onClick={() => setConfirmDeleteAddress(null)}
                            >
                                Cancel
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default ShippingAddressModal;
